<template>

	<div
		class="auto-suggest"
	>

		<span class="large-button flip-colours mini" @click="deleteFilter(true)" v-if="isAdmin">Reload Auto-Suggest for "{{searchKeyword}}"</span>

		<div
			v-for="(autoSuggestList, autoSuggestListIndex) in autoSuggestProcessed" 
			:key="autoSuggestListIndex"
			:class="{'auto-suggest-type-wrap':true,empty:(hidden(autoSuggestList.title)&&!showHidden)}"
		>
		
			<h2 class="auto-suggest-type-title">
				<span>{{autoSuggestList.title}}</span>
				<font-awesome-icon icon="eye-slash" :style="{ color: '#3b445b' }" title="Hide from export" @click="hide(autoSuggestList.title,null,true)" class="eyed" v-if="!hidden(autoSuggestList.title)" />
				<font-awesome-icon icon="eye" :style="{ color: '#3b445b' }" title="Un-hide from export" @click="hide(autoSuggestList.title,null,false)" class="eyed" v-if="hidden(autoSuggestList.title)" />
			</h2>

			<div v-if="!hidden(autoSuggestList.title)">

				<div
					v-for="(result, resultIndex) in autoSuggestList.results" 
					:key="resultIndex"
					:class="{'auto-suggest-type-question-wrap':true,empty:(hidden(autoSuggestList.title,result.title)&&!showHidden)}"
				>

					<h3 class="auto-suggest-type-question-title">
						<span>{{result.title}}</span>
						<font-awesome-icon icon="eye-slash" :style="{ color: '#3b445b' }" title="Hide from export" @click="hide(autoSuggestList.title,result.title,true)" class="eyed" v-if="!hidden(autoSuggestList.title,result.title)" />
						<font-awesome-icon icon="eye" :style="{ color: '#3b445b' }" title="Un-hide from export" @click="hide(autoSuggestList.title,result.title,false)" class="eyed" v-if="hidden(autoSuggestList.title,result.title)" />
					</h3>

					<ul v-if="result && result.results && result.results.length===0&&!hidden(autoSuggestList.title,result.title)" class="auto-suggest-type-question-list no-results"><li>No results</li></ul>

					<ul class="auto-suggest-type-question-list" v-if="result && result.results && result.results.length>0&&!hidden(autoSuggestList.title,result.title)">
						<li
							v-for="(line, lineIndex) in result.results" 
							:key="lineIndex"
							v-html="line"
						/>
					</ul>

				</div>

			</div>
		
		</div>

	</div>

</template>

<script>
import { mapMutations } from 'vuex'
import ApiService from '../../services/api.service'
import general from '../../utils/general'
export default {
	name: 'AutoSuggest',
	components: {  },
	props: {
		auto: {
			type: Object,
			default: () => { return {}; }
		},
		searchKeyword: {
			type: String
		},
		tab: {
			type: Object,
			default: () => { return {}; }
		},
		subTabId: {
			type: String,
			default:''
		},
		md5Key: {
			type: String
		},
		showHidden: {
			type: Boolean,
			default: true
		}
	},
	data() {

		return {
			
		}

	},
	watch: {

	},
	computed: {

		isAdmin () {

			return general.isAdmin();

		},

		autoSuggestProcessed () {

			let auto = [];

			if ( this.auto.results ) {

				Object.keys(this.auto.results).forEach ( function ( type ) {

					let r = { title: general.capitalizeFirstLetter(type), results: [] };

					Object.keys(this.auto.results[type]).forEach ( function ( q ) {

						let n = { title: general.capitalizeFirstLetter(q), results: this.auto.results[type][q] };

						if ( this.hidden(r.title,n.title) && !this.showHidden ) return;

						r.results.push( n );

					}.bind(this));
				
					if ( this.hidden(r.title) && !this.showHidden ) return;

					auto.push(r)

				}.bind(this));

			}

			return auto;

		},

    },
	created() {

		

	},
	methods: {

		...mapMutations('general',['updateLoadingText']),

		deleteFilter () {

			this.$emit('deleteFilter');

		},
		hidden( category, type ) {

			if ( type ) category += '.' + type.toLowerCase();

			let tab = this.subTabId ? this.tab.subTabs.find( t => !t.default && t._id.toString() === this.subTabId.toString() ) : this.tab;

			return tab.meta && tab.meta.hide && tab.meta.hide[category.toLowerCase()];

		},
		hide( type, word, hide ) {

			this.updateLoadingText("One moment...");

			let uri = 'googlea/auto/' + this.md5Key + '/' + this.tab._id;

			if ( this.subTabId ) uri += '/' + this.subTabId;

			ApiService.post( uri, { hide: hide, type: type, word: word } )
            .then( function(info) {

				this.updateLoadingText();
				this.$emit('fetchKeywords');

            }.bind(this))
            .catch( function(err) {}.bind(this));

		}

	}
}
</script>

<style lang="less" scoped>
@import './../../assets/css/less/_helper.less';
@import './../../assets/css/less/_settings.less';
.auto-suggest {

	.auto-suggest-type-wrap {

		margin-top: 30px;
		position: relative;

		&.empty {

			margin-top: 0;

		}

		.auto-suggest-type-title {

			margin: 0 0 10px;

		}

		.eyed {

			display: inline-block;
			opacity:0.7;
			cursor: pointer;
			font-size: 0.8em;

			&:hover {

				opacity: 1;

			}

		}

		&.hide {

			.auto-suggest-type-question-title, .auto-suggest-type-question-list, .eyed {

				opacity: 0.5;

			}

			.eyed {

				&:hover {

					opacity: 1;

				}

			}

		}

		.auto-suggest-type-question-wrap {

			margin: 0 0 20px;
			position: relative;

			.auto-suggest-type-question-title {

				margin-bottom: 5px;

			}

			.auto-suggest-type-question-list {

				list-style: none;
				margin: 0;
				padding: 0;

				&.no-results {

					li {

						.opacity(0.6);

					}

				}

			}

			&.hide {

				.auto-suggest-type-question-title, .auto-suggest-type-question-list, .eyed {

					opacity: 0.5;

				}

				.eyed {

					&:hover {

						opacity: 1;

					}

				}

			}

		}

	}

}
@media screen and (min-width: 480px) {
	.search-box {

		

	}
}
@media screen and (min-width: 768px) {
	.auto-suggest {

		.auto-suggest-type-wrap {

			.auto-suggest-type-title {
				
				margin: 0;

			}

			.auto-suggest-type-question-wrap {
				
				display: inline-block;
				width: 48%;
				margin: 1% 1% 0 0;
				vertical-align: top;
				border: 1px solid #EAEDF0;
				padding: 10px;
				.rounded(5px);

				.auto-suggest-type-question-title {

					

				}

				.auto-suggest-type-question-list {

					

				}

			}

		}

	}
}
@media screen and (min-width: 960px) {

	
}
</style>